export default "/_next/static/images/hearts-3bdeb19a82372fe0ddd9c88dbe474f9e.png";